module.exports = __webpack_public_path__ + "media/images/step-recource---d78e2342.jpg";